import * as React from "react";

import styles from "./index.module.css";

interface Props {
  baozhi_info: any[];
  onGoToTab: Function;
}

const Index: React.FC<Props> = ({ baozhi_info, onGoToTab }) => {
  const onGoToSlide: Function = (index: number) => (e: any) => {
    e.preventDefault();
    onGoToTab(index);
  };

  return (
    <div className={styles.Index}>
      {baozhi_info.map((banmian, index) => (
        <div
          key={banmian.banmian_id}
          className={styles.banmianWrapper}
          onClick={onGoToSlide(index)}
        >
          <div
            className={styles.banmian}
            dangerouslySetInnerHTML={{ __html: banmian.imagebg }}
          />
          <div className={styles.banmianTitle}>{banmian.pagenum}</div>
        </div>
      ))}
    </div>
  );
};

export default Index;
